import React from "react";
import defaultImg from "../../../images/pic1.jpg";

const EmployeeCard = ({ emp }) => {
 const tasks = emp.tasks ?? emp.totalAssignedTasks ?? 0;
 const workload = emp.workload ?? emp.workloadPercent ?? 0;

 // Map status (fallback-safe)
 let status = emp.status ?? emp.availabilityStatus ?? "Available";

 // If client wants front-end to enforce workload-based state:
 if (status !== "On Leave") {
 if (workload >= 150) status = "High Load";
 else if (workload >= 100) status = "Busy";
 else status = "Available";
 }

 const workloadText = `${Math.round(workload)}%`;

 let workloadColor = "#198754"; // green
 if (workload >= 100 && workload < 150) workloadColor = "#fd7e14"; // orange
 if (workload >= 150) workloadColor = "#dc3545"; // red

 const getStatusBadge = (status) => {
 switch (status) {
 case "Busy":
 return { bg: "#fff3cd", color: "#856404" }; // yellow
 case "High Load":
 return { bg: "#f8d7da", color: "#842029" }; // red
 case "On Leave":
 case "Leave":
 return { bg: "#f1f1f1", color: "#6c757d" }; // gray
 case "Available":
 default:
 return { bg: "#d1e7dd", color: "#0f5132" }; // green
 }
 };

 const badge = getStatusBadge(status);

 return (
 <div className="border rounded p-3 bg-white mb-3">
 <div className="d-flex justify-content-between align-items-start">
 <div className="d-flex align-items-center">
 <img
 src={emp.image || defaultImg}
 alt={emp.name}
 width={40}
 height={40}
 className="rounded-circle me-2"
 style={{ objectFit: "cover" }}
 onError={(e) => (e.target.src = defaultImg)}
 />
 <div>
 <div style={{ fontWeight: 600, fontSize: "14px" }}>{emp.name}</div>
 <div style={{ fontSize: "12px", color: "#6c757d" }}>
 {emp.role || "Employee"} • {emp.level || "N/A"}
 </div>
 </div>
 </div>

 <span
 className="px-2 py-1 rounded"
 style={{
 fontSize: "11px",
 background: badge.bg,
 color: badge.color,
 fontWeight: 600
 }}
 >
 {status}
 </span>
 </div>

 <div style={{ fontSize: "12px", color: "#6c757d", marginTop: "4px" }}>
 {tasks} tasks
 </div>

 <div className="mt-2">
 <div
 className="d-flex justify-content-between"
 style={{ fontSize: "12px", color: "#6c757d" }}
 >
 <span>Workload</span>
 <span style={{ fontSize: "11px", fontWeight: 600 }}>{workloadText}</span>
 </div>

 <div className="progress" style={{ height: "6px", marginTop: "4px" }}>
 <div
 className="progress-bar"
 role="progressbar"
 style={{
 width: `${Math.min(workload, 200)}%`,
 background: workloadColor
 }}
 title={workloadText}
 ></div>
 </div>
 </div>
 </div>
 );
};

export default EmployeeCard;
